<div class="overlay-container" *ngIf="show">
  <div class="modal-box">
    <ng-content></ng-content>
  </div>
</div>
